import { EyeOutlined, AudioOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, Spin, Tooltip, notification } from "antd";
import Modal from "antd/lib/modal/Modal";
import { ColumnType } from "antd/lib/table";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { BiCloudLightRain } from "react-icons/bi";
import CTable from "../../components/table/CTable";
import "./voice.styles.scss";
import Upload, { RcFile } from "antd/lib/upload";
import axios from "axios";
import { API_URL } from "../../enums/api.enums";

const Voice = () => {

    const [textSearch, setTextSearch] = useState("");
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [fileUploadLst, setFileUploadList] = useState<RcFile[]>([]);
    const [checkLstFileUploadLst, setCheckLstFileUploadLst] = useState<RcFile[]>([]);
    const [lstVoiceReal, setLstVoiceReal] = useState<any>([]);


    const [secondaryVoice, setSecondaryVoice] = useState<any[]>([]);
    const [checkProgress, setCheckProgress] = useState(false);
    const [checkUploadVoice, setCheckUploadVoice] = useState(false);
    const [isOpenModalView, setIsOpenModalView] = useState(false);
    const [voice, setVoice] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [indexVoice, setIndexVoice] = useState(0);
    const columns: ColumnType<any>[] = [
        {
            title: "Số thứ tự",
            width: "120px",
            render: (_, __, rowIndex) =>
            (
                <div className="span-table" style={{ textAlign: "center" }}>
                    {rowIndex + 1}
                </div>
            ),
        },
        {
            title: "Tên giọng đọc",
            dataIndex: "name",
            key: "name",
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <div style={{ textAlign: "center" }} >{record.name}</div>
                </div>
            )
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <div style={{ textAlign: "center" }} >{record.status}</div>
                </div>
            )
        },
        // {
        //     title: 'Dung lượng file',
        //     dataIndex: 'sizeFile',
        //     key: 'sizeFile',
        //     render: (_, record) => (
        //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        //             <div style={{ textAlign: "center" }} >{record.sizeFile ? record.sizeFile : 'Chưa xác định'}</div>
        //         </div>
        //     )
        // },
        // {
        //     title: 'Thời lượng file',
        //     dataIndex: 'sizeDuration',
        //     key: 'sizeDuration',
        //     render: (_, record) => (
        //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
        //             <div style={{ textAlign: "center" }} >{record.sizeDuration ? record.sizeDuration : 'Chưa xác định'}</div>
        //         </div>
        //     )
        // },
        // {
        //     title: "Thao tác",
        //     key: "action",
        //     render: (_, record) => (
        //         <Space size="middle" style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', gap: 10 }}>
        //             <Tooltip placement="top" title={"Xem chi tiết"} >
        //                 <Spin spinning={(isLoading && indexVoice === record.id)}>
        //                     <EyeOutlined className="icon-action" onClick={(event) => handleView(record)} />
        //                 </Spin>
        //             </Tooltip>
        //             <Tooltip placement="top" title={"Huấn luyện voice"}>
        //                 {(record.status === 'Đã huấn luyện' || checkProgress) ?
        //                     <BiCloudLightRain className="icon-action" style={{ color: 'gray' }} />
        //                     :
        //                     <BiCloudLightRain className="icon-action" onClick={() => handleTrainingVoice(record)} />
        //                 }
        //             </Tooltip>
        //         </Space>
        //     ),
        // },
    ];

    const [mp3FileAdio, setMp3FileAdio] = useState<any>(null);
    const audioRef = useRef<HTMLAudioElement>(null);
    const [audioDiv, setAudioDiv] = useState<any>();
    useEffect(() => {
        getALlLstUploadVoice();
    }, []);

    useEffect(() => {
        fetchData();
    }, [secondaryVoice]);

    useEffect(() => {
        console.log(mp3FileAdio, indexVoice);

        if (mp3FileAdio && indexVoice !== 0) {
            setAudioDiv(
                <audio controls ref={audioRef}>
                    <source src={`${API_URL.HOST_UPLOAD_VOICE}/get-audio-sample/${indexVoice}`} type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            )
        }
    }, [mp3FileAdio, indexVoice])


    const fetchData = async () => {
        let isProgress = false;

        // Update to use the new voice list structure
        const tmp2 = await Promise.all(secondaryVoice.map(async (item: any) => {
            let check = ''
            let sizeFile = 0;
            let sizeDuration = 0;

            // Use the actual status from the API response or default logic
            if (item.status) {
                switch (item.status) {
                    case 'progress':
                        check = "Đang huấn luyện"
                        isProgress = true;
                        break;
                    case 'ok':
                        check = "Đã huấn luyện"
                        break;
                    default:
                        check = "Chưa huấn luyện"
                        break;
                }
            } else {
                // Default to trained status if no status field
                check = "Đã huấn luyện"
            }

            return {
                id: item.id,
                name: item.name || item.id, // Use name field if available, fallback to id
                status: check,
                sizeFile: sizeFile ? sizeFile + " MB" : 'Chưa xác định',
                sizeDuration: sizeDuration ? sizeDuration + " phút" : 'Chưa xác định',
                path: item.path, // Store path for future use
                ref_text: item.ref_text // Store reference text
            }
        }))

        console.log(tmp2);

        setCheckProgress(isProgress);
        setLstVoiceReal([...tmp2])
    }

    const onChangePagination = (event: any) => {
        // Pagination logic for voice list if needed in the future
        console.log('Pagination:', event);
    };

    const onChangeInput = (event: any) => {
        setTextSearch(event.target.value);
    };

    const onSearch = () => {
        // Search logic for voice list if needed in the future
        console.log('Search:', textSearch);
    };

    const onCancelAddAuthor = () => {
        setOpenModalAdd(false)
    }

    const onAdd = async (value: any) => {
        console.log(value);

        const formData = new FormData();
        formData.append('ref_audio', value.file.file);
        formData.append('name', value.name);

        setCheckUploadVoice(true);
        try {
            const res = await fetch(`${API_URL.HOST_UPLOAD_VOICE}/upload-voice`, {
                method: "POST",
                headers: {
                    'accept': 'application/json'
                },
                body: formData,
            });

            const data = await res.json();
            console.log(data);

            if (res.status !== 200) {
                notification.error({
                    message: "Thêm giọng đọc thất bại",
                    description: data.message || "Có lỗi xảy ra",
                    duration: 2,
                } as any);
                return;
            }
            else {
                notification.success({
                    message: "Tải lên thành công",
                    description: `File: ${data.filename}, Tên: ${data.name}`,
                    duration: 2,
                } as any);

                setOpenModalAdd(false);
                getALlLstUploadVoice();
            }

            setCheckUploadVoice(false);

        } catch (error) {
            console.error('Upload error:', error);
            notification.error({
                message: "Thêm giọng đọc thất bại",
                description: "Có lỗi xảy ra khi tải lên",
                duration: 2,
            } as any);
            setCheckUploadVoice(false);
        }
    }

    const handleTrainingVoice = async (record: any) => {
        setCheckProgress(true);
        await axios.get(`${API_URL.HOST_UPLOAD_VOICE}/${API_URL.TRAING_SECONDARY_VOICE}?voiceId=${record.name}`)
            .then((res) => {
                console.log(res.data);
                if (res.data.status === "failed") {
                    notification.error({
                        message: "Đã bắt đầu huấn luyện giọng đọc",
                        description: res.data.message,
                        duration: 2,
                    } as any);
                    return;
                }
                else {
                    notification.success({
                        message: "Huấn luyện giọng đọc thành công",
                        description: res.data.message,
                        duration: 2,
                    } as any);

                    getALlLstUploadVoice();

                }
            })
            .catch((err) => {
                console.log(err);
            })

    }



    const getALlLstUploadVoice = async () => {
        await axios.get(`${API_URL.HOST_UPLOAD_VOICE}/list-voices`)
            .then((res) => {
                console.log(res.data);

                if (res.data && res.data.length > 0) {
                    setSecondaryVoice(res.data)
                }
                else {
                    setSecondaryVoice([])
                }

            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleView = async (record: any) => {
        console.log(record);
        let sizeFile = 0;
        let sizeDuration = 0;
        setIndexVoice(record.id);
        setIsLoading(true);

        // Get audio sample - this endpoint should exist based on the audio tag
        try {
            const audioRes = await axios.get(`${API_URL.HOST_UPLOAD_VOICE}/get-audio-sample/${record.id}`);
            console.log(audioRes.data);
            if (audioRes.data) {
                setMp3FileAdio(audioRes.data);
            }
        } catch (err) {
            console.log('Audio sample error:', err);
        }

        // Get file info if endpoint exists
        try {
            const infoRes = await axios.get(`${API_URL.HOST_UPLOAD_VOICE}/get-info-of-audio-file/${record.id}`);
            console.log(infoRes.data);
            sizeFile = infoRes.data.size;
            sizeDuration = infoRes.data.duration;
        } catch (err) {
            console.log('File info error:', err);
        }

        // Change size Duration to minute
        sizeDuration = Math.round(sizeDuration);
        console.log(sizeDuration);

        setIsOpenModalView(true);
        setVoice({
            id: record.id,
            name: record.name,
            status: record.status,
            sizeFile: sizeFile ? sizeFile + " MB" : 'Chưa xác định',
            sizeDuration: sizeDuration ? sizeDuration + " phút" : 'Chưa xác định',
        });

        setIsLoading(false);
    }

    const handleCloseModalView = () => {
        setIsOpenModalView(false);
        setMp3FileAdio(null);
        setIndexVoice(0);
        if (audioRef.current) {
            // audioRef.current.src = "";
            audioRef.current.load();
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }



    return (
        <motion.div
            className="sketch-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="table-area">
                <CTable
                    tableMainTitle="Danh sách giọng đọc"
                    allowTextSearch={false}
                    onChangeInput={onChangeInput}
                    onSearch={onSearch}
                    titleOfColumnList={columns}
                    data={lstVoiceReal}
                    totalRecord={lstVoiceReal.length}
                    titleAddButton="Thêm giọng đọc"
                    textSearch="Nhập tên giọng đọc"
                    onChangePagination={onChangePagination}
                    allowAddObject={true}
                    pageSize={10}
                    size={400}
                    handleAddObject={() => setOpenModalAdd(true)}
                />
            </div>
            {openModalAdd &&
                <Modal
                    open={openModalAdd}
                    onOk={() => setOpenModalAdd(false)}
                    closable={true}
                    onCancel={onCancelAddAuthor}
                    title={
                        <Space>
                            <AudioOutlined />
                            <span>Thêm giọng đọc</span>
                        </Space>
                    }
                    className="modal-add-voice"
                    footer={false}
                    width={500}>
                    <Form onFinish={onAdd}>
                        <Form.Item
                            label={
                                <Space>
                                    <AudioOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                    <span>Tên giọng đọc</span>
                                </Space>
                            }
                            name="name"
                            rules={[{ required: true, message: "Vui lòng nhập tên giọng đọc!" }]}
                        >
                            <Input placeholder="Nhập tên giọng đọc" />
                        </Form.Item>
                        <Form.Item
                            label={
                                <Space>
                                    <AudioOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                    <span>File giọng đọc</span>
                                </Space>
                            }
                            name="file"
                            rules={[{ required: true, message: "Vui lòng chọn file giọng đọc!" }]}
                        >
                            <Upload.Dragger
                                maxCount={1}
                                listType="picture"
                                action={"https://localhost:3000/"}
                                showUploadList={{
                                    showRemoveIcon: true,
                                }}
                                onChange={(info) => {
                                    setCheckLstFileUploadLst(info.fileList as RcFile[]);
                                }}
                                accept=".mp3, .wav"
                                beforeUpload={(file) => {
                                    let tmplst = fileUploadLst;
                                    tmplst.push(file);
                                    setFileUploadList(tmplst);
                                    return false;
                                }}
                                progress={{
                                    strokeWidth: 3,
                                    strokeColor: {
                                        "0%": "#a9eab3",
                                        "100%": "#27CA40",
                                    },
                                    style: { top: 12 },
                                }}
                            >
                                <p className="ant-upload-drag-icon">
                                    <AudioOutlined />
                                </p>
                                <p className="ant-upload-text">Click hoặc kéo file giọng đọc vào đây để tải lên</p>
                                <p className="ant-upload-hint">Hỗ trợ file .mp3, .wav</p>
                            </Upload.Dragger>

                        </Form.Item>
                        <Form.Item
                            style={{ textAlign: "center", marginTop: "var(--spacing-4)" }}

                        >
                            <Button loading={checkUploadVoice} type="primary" htmlType="submit" icon={<PlusOutlined />}>
                                Thêm giọng đọc
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            }
            {/* Tạo modal view voice */}
            <Modal
                title={
                    <Space>
                        <AudioOutlined />
                        <span>Thông tin giọng đọc</span>
                    </Space>
                }
                visible={isOpenModalView}
                onCancel={handleCloseModalView}
                footer={null}
                width={600}
                className="voice-view-modal"
            >
                <div className="voice-info">
                    <div className="voice-details">
                        <div className="voice-detail-item">
                            <div className="detail-label">Tên giọng đọc</div>
                            <div className="detail-value">{voice.name}</div>
                        </div>
                        <div className="voice-detail-item">
                            <div className="detail-label">Trạng thái</div>
                            <div className="detail-value">{voice.status}</div>
                        </div>
                        <div className="voice-detail-item">
                            <div className="detail-label">Dung lượng file</div>
                            <div className="detail-value">{voice.sizeFile}</div>
                        </div>
                        <div className="voice-detail-item">
                            <div className="detail-label">Thời lượng file</div>
                            <div className="detail-value">{voice.sizeDuration}</div>
                        </div>
                    </div>

                    <div className="voice-audio">
                        <div className="audio-label">Giọng nghe thử</div>
                        {mp3FileAdio ? (
                            <div className="audio-player">
                                {audioDiv}
                            </div>
                        ) : (
                            <div className="no-audio">
                                Chưa có file nghe thử
                            </div>
                        )}
                    </div>
                </div>
            </Modal>


        </motion.div >
    );
};

export default Voice;
